import { rest } from 'msw';
import { getConfig } from 'shared/config';
import {
  activeSimcardMock,
  allSimDataResponses,
  allSimDataStates,
  fetchCardsMock,
  installingEsim,
  isEligible,
  mobileCoreMock,
  mobileMenuDetails,
  mobileSavingsMock,
  mobileSimcardMock,
  mobileUpgradeMock,
  subscriptionHeaderMock,
  usageOverviewMockFreeData,
  usageSpecificationsMockOdin,
} from '.';

const odinAPI = getConfig().odin?.host;
const mobileAPI = import.meta.env.PUBLIC_MOBILE_API_URL;

export const handlers = [
  rest.get(`${odinAPI}/yousee/selfcare/products/MOCK_MOBILE/menu-details`, (req, res, ctx) =>
    res(ctx.json(mobileMenuDetails)),
  ),
  rest.get(`${mobileAPI}/core/:id`, (req, res, ctx) => res(ctx.json(mobileCoreMock))),
  rest.get(`${mobileAPI}/mobile-savings/:id`, (req, res, ctx) => res(ctx.json(mobileSavingsMock))),
  rest.get(`${mobileAPI}/subscription-header/:id`, (req, res, ctx) =>
    res(ctx.json(subscriptionHeaderMock)),
  ),
  rest.get(`${mobileAPI}/simcard-service/:id`, (req, res, ctx) =>
    res(ctx.json(mobileSimcardMock)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/mobile/:id/sim`, (req, res, ctx) => {
    // NOTE - Keep commented lines to test different simcard/e-sim status
    // return res(ctx.json(sim.activeSimcardMock));
    // return res(ctx.json(sim.orderedSimcardMock));
    // return res(ctx.json(sim.readyForActivation));
    // return res(ctx.json(sim.pendingActivation));
    // return res(ctx.json(sim.activeEsimMock));
    // return res(ctx.json(sim.orderedEsim));
    return res(ctx.json(installingEsim));
  }),
  rest.get(`*/ghapi/kundeservice/redisclient/get`, (req, res, ctx) =>
    res(ctx.delay(100), ctx.json('esim')),
  ),
  rest.post(`*/ghapi/kundeservice/redisclient/set`, (req, res, ctx) => res(ctx.delay(100))),
  rest.post(`${odinAPI}/yousee/selfcare/mobile/:id/sim/activate`, (req, res, ctx) =>
    res(ctx.text('OK')),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/mobile/:id/changedetails`, (req, res, ctx) =>
    res(
      ctx.json({
        canChange: true,
        hasDobbeltData: false,
        affectedBasisNumber: '',
        affectedExtraNumbers: [],
      }),
    ),
  ),
  rest.post(`${odinAPI}/yousee/selfcare/mobile/esim/eligible`, (req, res, ctx) => {
    return res(ctx.json(isEligible));
  }),
  rest.post(`${odinAPI}/yousee/selfcare/mobile/:id/sim`, (req, res, ctx) =>
    res(
      ctx.json({
        productName: 'SIM-kort ICC nummer:',
        parentProductName: '',
        orderId: '51883673',
        orderDate: '2022-05-04T14:18:36+02:00',
        cmsRef: 'C8217607',
        email: 'stsoer@nuuday.dk',
      }),
    ),
  ),
  rest.post(`${odinAPI}/yousee/selfcare/mobile/:id/esim`, (req, res, ctx) =>
    res(
      ctx.json({
        productName: 'SIM-kort ICC nummer:',
        parentProductName: '',
        orderId: '51883673',
        orderDate: '2022-05-04T14:18:36+02:00',
        cmsRef: 'C8217607',
        email: 'stsoer@nuuday.dk',
      }),
    ),
  ),
  rest.post(`${odinAPI}/yousee/selfcare/mobile/:id/esimsecrets`, (req, res, ctx) =>
    res(
      ctx.json({
        pin: '2027',
        qrCodeUrl: 'LPA:1$rsp-0001.oberthur.net$6QFDG-2E3A2-CFZN8-DXR10',
        readyForActivation: true,
        simNo: '89450120200623008069',
      }),
    ),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/subscriptions/:id/telespecifications`, (req, res, ctx) =>
    res(ctx.json(usageSpecificationsMockOdin)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/subscriptions/:id/hasEncryptedCpr`, (req, res, ctx) =>
    res(ctx.json({ hasEncryptedCpr: true })),
  ),
  rest.post(`${odinAPI}/yousee/selfcare/subscriptions/:id/telespecifications`, (req, res, ctx) =>
    res(ctx.json(usageSpecificationsMockOdin)),
  ),
  rest.get(
    `${mobileAPI}/usage-overview/usage/:id`,
    (req, res, ctx) => res(ctx.json(usageOverviewMockFreeData)), // can be switched to usageOverviewMock, which does not have free data
  ),
  rest.get(`${mobileAPI}/mobile-product-card/fetchCards`, (req, res, ctx) =>
    res(ctx.json(fetchCardsMock)),
  ),
  rest.get(`${mobileAPI}/mobile-upgrade/changedetails/:id`, (req, res, ctx) =>
    res(ctx.json(mobileUpgradeMock)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/mobile/:id/sim`, (req, res, ctx) =>
    res(ctx.json(activeSimcardMock)),
  ),
  rest.get(`${odinAPI}/yousee/selfcare/mobile/:id/sim/data`, (req, res, ctx) =>
    res(ctx.json(allSimDataStates.state1)),
  ),
  rest.post(`${odinAPI}/yousee/selfcare/mobile/:id/sim/data`, (req, res, ctx) =>
    res(ctx.json(allSimDataResponses.simDataOrderResponseOk)),
  ),
  rest.delete(`${odinAPI}/yousee/selfcare/mobile/:id/sim/data`, (req, res, ctx) =>
    res(ctx.json(allSimDataResponses.simDataDeleteResponseOk)),
  ),
  rest.post(
    `${odinAPI}/yousee/selfcare/mobile/:id/sim/data/:productCode/reorder`,
    (req, res, ctx) => res(ctx.json(allSimDataResponses.simDataOrderResponseOk)),
  ),
];
